import React from "react";

const AviatorFrame = ({ src, title }) => (
  <iframe
    className="pr-0 pl-0 col-md-12"
    width={window.screen.width}
    height="700"
    title={title}
    style={{ borderRadius: 40}}
    src={src}
    frameBorder="0"
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
    allowFullScreen
  ></iframe>
);

export default AviatorFrame;
